import { Navigate } from "react-router";

import { featureFlags } from "shell/platform/config/featureFlags";
import { pathsSchema } from "shell/platform/config/paths";
import { SPONSOR_GUARD_ROLES } from "shell/platform/constants/constants";
import { useRoles } from "shell/platform/hooks/useRoles";

export const DefaultLandingPage = () => {
  const { hasRole } = useRoles();

  const isInternal = hasRole(["Internal", "Internal Read Only"]);

  if (isInternal && featureFlags.isProd) {
    return <Navigate to={pathsSchema.organizations.index} />;
  }

  if (hasRole(SPONSOR_GUARD_ROLES)) {
    return <Navigate to={pathsSchema.portal.sponsorGuard.index} />;
  }

  if (hasRole(["Organisation Manager"])) {
    return <Navigate to={pathsSchema.organizations.index} />;
  }

  if (hasRole(["Organisation Admin"])) {
    return <Navigate to={pathsSchema.portal.organization.index} />;
  }

  return <Navigate to={pathsSchema.portal.index} />;
};
